import { z } from "zod";
import { IdSchema } from "./primitives.js";
export const WorkforceRoleSchema = z.enum([
    "physician",
    "nurse_ma",
    "front_desk",
    "referral_coordinator",
    "billing",
    "clinic_admin",
    "auditor",
    "system_agent",
]);
export const PrincipalTypeSchema = z.enum(["human", "agent", "service"]);
export const ActorContextSchema = z.object({
    tenantId: IdSchema,
    actorId: IdSchema,
    role: WorkforceRoleSchema,
    principalType: PrincipalTypeSchema,
    siteId: IdSchema,
    aal: z.enum(["aal1", "aal2"]),
});
//# sourceMappingURL=actor.js.map